import { Container } from 'inversify';
import { createContext } from 'react';

export interface DIContextProps {
  mainContainer?: Container;
}

export const DIContext = createContext<DIContextProps>({
});
